
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.3 2.588a13 13 0 00-10.05 8.617l5.61 1.907a7.075 7.075 0 015.47-4.69L13.3 2.588zM17.43 28.253a12.999 12.999 0 0010.159-7.94l-5.483-2.244a7.075 7.075 0 01-5.53 4.322l.854 5.862z","fill":"#E345FF"}}),_c('path',{attrs:{"d":"M25.525 15.643c0 5.505-4.462 9.967-9.967 9.967-5.505 0-9.967-4.462-9.967-9.967 0-5.505 4.462-9.967 9.967-9.967 5.505 0 9.967 4.462 9.967 9.967z","stroke":"#fff"}}),_c('path',{attrs:{"d":"M27.582 20.33A13 13 0 0013.25 2.597l1.052 5.83a7.075 7.075 0 017.8 9.652l5.48 2.251zM3.244 11.224a13 13 0 0014.237 17.022l-.876-5.86a7.075 7.075 0 01-7.749-9.264l-5.612-1.898z","fill":"#5935DD"}})])
          )
        }
      }
    